<div class="d-flex border-dark-top">
  <div *ngFor="let tab of tabs; let i = index"
    class="p-2 flex-fill d-flex justify-content-center align-items-center disable-select"
    [ngClass]="(tabSelect == tab)?'menu-item-active':'menu-item'" (click)="changeTab(tab)">
    <i class="{{tab?.icon}} mr-1"></i>
    <span>{{tab?.name}}</span>
  </div>
</div>
<app-note-type *ngIf="tabSelect?.id == permission.note_type_id"></app-note-type>
<app-note-list *ngIf="tabSelect?.id == permission.note_id"></app-note-list>